export { default } from './BoldedText';
